import { IconName } from '@flatfile/baseline'
import { EntitlementKey } from '../../hooks/useEntitlements'

export const globalLinks: { icon: IconName; label: string; link: string; entitlement?: EntitlementKey }[] = [
  {
    icon: 'truck',
    label: 'Async Jobs',
    link: '/jobs',
  },
  {
    icon: 'console',
    label: 'Logs',
    link: '/logs',
  },
  {
    icon: 'play',
    label: 'Agents',
    link: '/agents',
  },
  {
    icon: 'key-2',
    label: 'API Keys & Secrets',
    link: '/keys-and-secrets',
  },
  {
    icon: 'calendar-1',
    label: 'Data Retention',
    link: '/data-retention',
    entitlement: 'dataRetention',
  },
]

export const resources: { icon: IconName; label: string; url: string }[] = [
  {
    icon: 'book',
    label: 'Developer Docs',
    url: 'https://flatfile.com/docs',
  },
  {
    icon: 'code-brackets',
    label: 'API Reference',
    url: 'https://reference.flatfile.com',
  },
  {
    icon: 'newspaper',
    label: 'Read Changelog',
    url: 'https://flatfile.com/docs/changelog',
  },
  {
    icon: 'external-link',
    label: 'System Status',
    url: 'https://status.flatfile.io',
  },
]

export const support: { icon: IconName; label: string }[] = [
  {
    label: 'Talk to Support',
    icon: 'circle-questionmark',
  },
]
